export function timeAgo(s) {
  const sec = Math.max(0, Math.floor((Date.now() - new Date(s).getTime()) / 1000));
  if (sec < 60) return "gerade eben";
  if (sec < 3600) return `vor ${Math.floor(sec / 60)} Min.`;
  if (sec < 86400) return `vor ${Math.floor(sec / 3600)} Std.`;
  if (sec < 604800) { const d = Math.floor(sec / 86400); return `vor ${d} ${d === 1 ? "Tag" : "Tagen"}`; }
  return new Date(s).toLocaleDateString("de-DE", { day: "2-digit", month: "short", year: "numeric" });
}
